/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_MovementInputs */

const en_field_movement = /** @type {(inputs: Field_MovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Movement`)
};

const es_field_movement = /** @type {(inputs: Field_MovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Movimiento`)
};

const fr_field_movement = /** @type {(inputs: Field_MovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mouvement`)
};

const de_field_movement = /** @type {(inputs: Field_MovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uhrwerk`)
};

const ja_field_movement = /** @type {(inputs: Field_MovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ムーブメント`)
};

const zh_field_movement = /** @type {(inputs: Field_MovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`机芯`)
};

const ar_field_movement = /** @type {(inputs: Field_MovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحركة`)
};

const id_field_movement = /** @type {(inputs: Field_MovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesin`)
};

const it_field_movement = /** @type {(inputs: Field_MovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Movimento`)
};

const ru_field_movement = /** @type {(inputs: Field_MovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Механизм`)
};

const pt_field_movement = /** @type {(inputs: Field_MovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Movimento`)
};

const ko_field_movement = /** @type {(inputs: Field_MovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무브먼트`)
};

/**
* | output |
* | --- |
* | "Movement" |
*
* @param {Field_MovementInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_movement = /** @type {((inputs?: Field_MovementInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_MovementInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_movement(inputs)
	if (locale === "es") return es_field_movement(inputs)
	if (locale === "fr") return fr_field_movement(inputs)
	if (locale === "de") return de_field_movement(inputs)
	if (locale === "ja") return ja_field_movement(inputs)
	if (locale === "zh") return zh_field_movement(inputs)
	if (locale === "ar") return ar_field_movement(inputs)
	if (locale === "id") return id_field_movement(inputs)
	if (locale === "it") return it_field_movement(inputs)
	if (locale === "ru") return ru_field_movement(inputs)
	if (locale === "pt") return pt_field_movement(inputs)
	return ko_field_movement(inputs)
});